export default __webpack_public_path__ + "static/media/strive-health.63ac6f61.svg";